import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries';

const DetalleNivel1 = ({elemento}) => {
  return (
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaCreate.substr(0, 10)}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProducto}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioCreate}</td>
   </tr>  
  )
};

const Lista = ({list}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// const AddProcEjec2 = ({this.props.styles, handleSubmit, handleChange, args, errors}) => {
  class AddCotizacionPro2 extends React.Component{
    state={argsAdd: {}}

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    this.setState({argsAdd})
  }

  render(){
    const {argsAdd} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let args = Object.assign({}, this.props.args, argsAdd)

    let listCompra = []
    if(this.props.allSolicCompra.allSolicCompra){listCompra = this.props.allSolicCompra.allSolicCompra}

  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Solicitud de compra nueva
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
          <div className="row container">              
            <div className="column" width="100%">  
              <Form.Field>
                  <label style={this.props.styles.label}>Motivo de solicitud</label>
                  <Form.Input autoComplete="off" name="observaciones" id="observaciones" onChange={this.props.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observaciones'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
              </Form.Field> 
            </div>
            <div className="column" width="100%">  
              <Form.Field>
                  <label style={this.props.styles.label}>Observaciones para la orden de compra (PDF)</label>
                  <Form.Input autoComplete="off" name="observacionesOC" id="observacionesOC" onChange={this.props.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observaciones'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
              </Form.Field> 
            </div>
          </div>
          <div className="row container">
            <div className="column" width="100%">                
              <Button style={this.props.styles.confirmar} type='submit' fluid>
                AGREGAR
              </Button>
            </div>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </div>
          <br/><br/>
          <div className="column" width="100%" align="center">  
                  {/* <label style={this.props.styles.label}>Solicitudes de compra de otras áreas</label> */}
          
            <label style={{color: 'black', fontSize: '1.3em', margin: '0.4em 0em 0em 0em'}}>
              Solicitudes de compra de otras áreas
            </label>
          </div>
          <div style={{height: '25em', overflow: 'auto'}}>
            <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
              <thead className=''>
                <tr className=''> 
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Fecha</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '67%'}}>Producto</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Cantidad</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Creada por</th>
                </tr>
              </thead>
              <Lista list={listCompra} />
            </table>
            <p></p>
          </div>


        </Form>
      </div>
    </div>
  )
  }
}

// export default AddProcEjec2
export default compose(
  graphql(queries.query.allSolicCompra, {name:'allSolicCompra',
    options: (props) => {return {variables: {tipoqry: `[{$match: {activo: 'S'}}]`
  }}}}),

  )(AddCotizacionPro2)